import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

export const Card = React.forwardRef(({ className, children, hover = false, interactive = false, ...props }, ref) => {
    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={cn(
                'bg-white rounded-xl shadow-sm border border-slate-200 transition-all duration-200',
                hover && 'hover:shadow-md',
                interactive && 'hover:shadow-lg hover:border-primary-300 cursor-pointer',
                className
            )}
            {...props}
        >
            {children}
        </motion.div>
    );
});

Card.displayName = 'Card';

export const CardHeader = ({ className, children, ...props }) => (
    <div className={cn('px-6 py-4 border-b border-slate-100', className)} {...props}>
        {children}
    </div>
);

export const CardTitle = ({ className, children, ...props }) => (
    <h3 className={cn('text-lg font-semibold text-slate-900', className)} {...props}>
        {children}
    </h3>
);

export const CardContent = ({ className, children, ...props }) => (
    <div className={cn('p-6', className)} {...props}>
        {children}
    </div>
);

export const CardFooter = ({ className, children, ...props }) => (
    <div className={cn('px-6 py-4 bg-slate-50 border-t border-slate-100 rounded-b-xl', className)} {...props}>
        {children}
    </div>
);
